import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Re-export formatters from central utils for backward compat
export { formatCurrency as fmtBRL, formatPercent as fmtPercent } from "@/shared/utils/formatters";

